<template>
  <!-- 全局悬浮按钮，通过定位和事件实现拖拽 -->
  <div
    class="drag-button"
    :style="{
      left: `${x}px`,
      top: `${y}px`,
      backgroundColor: '#2563EB'
    }"
    @mousedown.stop="startDrag"
    @touchstart.stop="startDrag"
  >
    <slot>
      <div ref="dragButton">
        <svg
          t="1762997532224"
          class="icon"
          viewBox="0 0 1024 1024"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          p-id="6426"
          width="28"
          height="28"
        >
          <path
            d="M64.956408 512.1361c0-246.308779 200.400193-446.708971 446.707948-446.708972 87.830371 0 172.97968 25.496697 245.897409 73.671907 14.70491 9.759271 18.899442 29.482475 9.070586 44.257993-9.69071 14.709003-29.414937 18.762319-44.327578 9.003048-62.469773-41.302685-135.249357-63.157435-210.642464-63.157435-211.120348 0-382.863874 171.811064-382.863874 382.933459 0 211.123418 171.743526 382.864898 382.863874 382.864897 211.121372 0 382.864898-171.741479 382.864898-382.864897 0-13.402241-0.617054-26.732851-1.993401-39.927362-1.785669-17.457604 10.927887-33.125445 28.453029-34.980699 17.524119-1.856277 33.261545 10.926864 35.049261 28.383444 1.579985 15.461133 2.338255 31.06246 2.338254 46.524617-0.001023 246.37734-200.332654 446.708971-446.711018 446.708971-246.306732 0-446.706925-200.330608-446.706924-446.708971z"
            fill="#ffffff"
            p-id="6427"
          ></path>
          <path
            d="M466.383056 751.549841c-10.69969 0-21.466917-4.129041-29.561269-12.247952L264.675078 566.67218c-16.32378-16.375969-16.32378-43.074028 0-59.380412 16.391319-16.306384 42.933835-16.306384 59.188031 0L466.383056 650.201595l363.978759-365.150444c16.321734-16.375969 42.86425-16.375969 59.119469 0 16.255219 16.445554 16.255219 43.004443 0 59.309804L495.873718 739.301889c-8.092305 8.118911-18.86158 12.247952-29.490662 12.247952z"
            fill="#ffffff"
            p-id="6428"
          ></path>
        </svg>
      </div>
    </slot>
    <el-tour @close="close" :model-value="open" :mask="false">
      <el-tour-step :target="dragButton" :scroll-into-view-options="false" :show-arrow="false">
        <template #header>
          <div style="">🎯 新人任务引导</div>
        </template>

        <div class="flx-justify-between mb20 mt20">
          <div style="display: flex; align-items: center">
            <span
              class="mr10"
              style="
                align-items: center;
                width: 25px;
                height: 25px;
                line-height: 25px;
                color: #ffffff;
                text-align: center;
                background-color: rgb(64 158 255);
                border-radius: 50%;
              "
              :style="{
                backgroundColor: formatVerifystyle
              }"
            >
              1
            </span>
            <span>实名认证</span>
          </div>
          <el-button v-if="verifyStatus === 0" @click="qurenzheng" type="primary"> 去认证 </el-button>
          <div v-if="verifyStatus === 1" style="display: flex; gap: 5px; align-items: center; color: #67c23a">
            已完成
            <svg
              t="1763631931589"
              class="icon"
              viewBox="0 0 1024 1024"
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              p-id="3889"
              width="20"
              height="20"
            >
              <path
                d="M506.0096 16.49664C228.71552 16.49664 3.92704 241.27488 3.92704 518.57408c0 277.2736 224.78848 502.07232 502.07232 502.07232s502.07232-224.79872 502.07232-502.07232c0-277.2992-224.78848-502.07744-502.0672-502.07744z m269.12256 369.54112l-312.40704 312.40192a33.4592 33.4592 0 0 1-47.32928 0l-156.20096-156.20096a33.46432 33.46432 0 0 1 0-47.32928 33.46944 33.46944 0 0 1 47.3344 0l132.53632 132.5312 288.73216-288.73728a33.46944 33.46944 0 1 1 47.3344 47.3344z m0 0"
                fill="#67c23a"
                p-id="3890"
              ></path>
            </svg>
          </div>
          <div v-if="verifyStatus === 2" style="color: #67c23a">实名审核中</div>
          <el-button v-if="verifyStatus === 3" @click="router.push('/userInfo')" type="warning">查看失败原因 </el-button>
        </div>
        <div class="flx-justify-between mb20">
          <div style="display: flex; align-items: center">
            <span
              class="mr10"
              style="
                align-items: center;
                width: 25px;
                height: 25px;
                line-height: 25px;
                color: #ffffff;
                text-align: center;
                background-color: rgb(144 147 153);
                border-radius: 50%;
              "
              :style="{
                backgroundColor: stepStatuStyle
              }"
            >
              2
            </span>
            <span>购买产品</span>
          </div>
          <el-button v-if="stepStatus < 1" disabled type="info">去购买</el-button>
          <el-button v-if="stepStatus == 1" @click="router.push('/product/equip')" type="primary">去购买</el-button>
          <div v-if="stepStatus === 2" style="display: flex; gap: 5px; align-items: center; color: #67c23a">
            已完成
            <svg
              t="1763631931589"
              class="icon"
              viewBox="0 0 1024 1024"
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              p-id="3889"
              width="20"
              height="20"
            >
              <path
                d="M506.0096 16.49664C228.71552 16.49664 3.92704 241.27488 3.92704 518.57408c0 277.2736 224.78848 502.07232 502.07232 502.07232s502.07232-224.79872 502.07232-502.07232c0-277.2992-224.78848-502.07744-502.0672-502.07744z m269.12256 369.54112l-312.40704 312.40192a33.4592 33.4592 0 0 1-47.32928 0l-156.20096-156.20096a33.46432 33.46432 0 0 1 0-47.32928 33.46944 33.46944 0 0 1 47.3344 0l132.53632 132.5312 288.73216-288.73728a33.46944 33.46944 0 1 1 47.3344 47.3344z m0 0"
                fill="#67c23a"
                p-id="3890"
              ></path>
            </svg>
          </div>
        </div>

        <div class="flx-justify-between">
          <div style="display: flex; align-items: center">
            <span
              class="mr10"
              style="
                align-items: center;
                width: 25px;
                height: 25px;
                line-height: 25px;
                color: #ffffff;
                text-align: center;
                background-color: rgb(144 147 153);
                border-radius: 50%;
              "
              :style="{
                backgroundColor: stepStatuStyle1
              }"
            >
              3
            </span>
            <span>绑定使用</span>
          </div>
          <el-button v-if="stepStatus < 2" disabled type="info">去绑定</el-button>
          <el-button v-if="stepStatus == 2" @click="router.push('/product/equip')" type="primary">去绑定</el-button>
          <div v-if="stepStatus === 3" style="display: flex; gap: 5px; align-items: center; color: #67c23a">
            已完成
            <svg
              t="1763631931589"
              class="icon"
              viewBox="0 0 1024 1024"
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              p-id="3889"
              width="20"
              height="20"
            >
              <path
                d="M506.0096 16.49664C228.71552 16.49664 3.92704 241.27488 3.92704 518.57408c0 277.2736 224.78848 502.07232 502.07232 502.07232s502.07232-224.79872 502.07232-502.07232c0-277.2992-224.78848-502.07744-502.0672-502.07744z m269.12256 369.54112l-312.40704 312.40192a33.4592 33.4592 0 0 1-47.32928 0l-156.20096-156.20096a33.46432 33.46432 0 0 1 0-47.32928 33.46944 33.46944 0 0 1 47.3344 0l132.53632 132.5312 288.73216-288.73728a33.46944 33.46944 0 1 1 47.3344 47.3344z m0 0"
                fill="#67c23a"
                p-id="3890"
              ></path>
            </svg>
          </div>
        </div>
        <div class="mt20">
          <el-progress
            :format="() => ` 当前进度：${percentage === 0 ? '0' : percentage === 33 ? '1' : percentage === 66 ? '2' : '3'}/3`"
            :percentage="percentage"
          />
        </div>
      </el-tour-step>
    </el-tour>
    <!-- 自定义按钮内容 -->
  </div>
</template>

<script lang="ts" setup>
// Vue 3 版本（如需 Vue 2，将 setup 改为 export default { data, methods... }）
import { ref, onMounted, onUnmounted, computed } from "vue";
import { useGlobalStore } from "@/stores/modules/global";
import { useUserStore } from "@/stores/modules/user";
import { useRouter } from "vue-router";
import { ElMessage } from "element-plus";

const router = useRouter();
const globalStore = useGlobalStore();
const userStore = useUserStore();
const open = computed(() => {
  return globalStore.showDragButton;
});
const verifyStatus = computed(() => {
  return userStore.userInfo.verifyStatus;
});

const stepStatus = computed(() => {
  return userStore.userInfo.stepStatus;
});

const percentage = computed(() => {
  let count = 0;
  if (userStore.userInfo.verifyStatus === 1) {
    count = 33;
  }
  if (stepStatus.value === 2) {
    count = 66;
  }
  if (stepStatus.value === 3) {
    count = 100;
  }
  return count;
});
// 按钮位置（初始在右下角）
const x = ref(window.innerWidth - 80);
const y = ref(380);
// 拖拽状态
const isDragging = ref(false);
// 记录初始拖拽位置差值
const offsetX = ref(0);
const offsetY = ref(0);

// 开始拖拽
const startDrag = e => {
  if (open.value) return;

  // 区分鼠标和触摸事件
  const clientX = e.type === "mousedown" ? e.clientX : e.touches[0].clientX;
  const clientY = e.type === "mousedown" ? e.clientY : e.touches[0].clientY;

  isDragging.value = true;
  // 计算鼠标/触摸点相对于按钮左上角的差值
  offsetX.value = clientX - x.value;
  offsetY.value = clientY - y.value;

  // 添加全局移动和结束事件（避免按钮脱离鼠标）
  document.addEventListener("mousemove", moveDrag);
  document.addEventListener("touchmove", moveDrag);
  document.addEventListener("mouseup", endDrag);
  document.addEventListener("touchend", endDrag);
};

// 拖拽移动
const moveDrag = e => {
  if (open.value) return;
  isDragging.value = false;
  const clientX = e.type === "mousemove" ? e.clientX : e.touches[0].clientX;
  const clientY = e.type === "mousemove" ? e.clientY : e.touches[0].clientY;

  // 计算新位置（减去初始差值，确保拖拽流畅）
  let newX = clientX - offsetX.value;
  let newY = clientY - offsetY.value;

  // 边界限制：避免按钮超出窗口可视区域
  const buttonWidth = 100; // 按钮宽度（需与样式一致）
  const buttonHeight = 40; // 按钮高度（需与样式一致）
  newX = Math.max(0, Math.min(newX, window.innerWidth - buttonWidth));
  newY = Math.max(0, Math.min(newY, window.innerHeight - buttonHeight));

  // 更新位置
  x.value = newX;
  y.value = newY;
};

// 结束拖拽
const endDrag = () => {
  if (open.value) return;
  //为点击
  if (isDragging.value) {
    globalStore.setGlobalState("showDragButton", true);
  }

  // 移除全局事件（避免内存泄漏）
  document.removeEventListener("mousemove", moveDrag);
  document.removeEventListener("touchmove", moveDrag);
  document.removeEventListener("mouseup", endDrag);
  document.removeEventListener("touchend", endDrag);
};

// 窗口大小变化时，调整按钮位置（避免超出边界）
const handleResize = () => {
  const buttonWidth = 100;
  const buttonHeight = 40;
  x.value = Math.min(x.value, window.innerWidth - buttonWidth);
  y.value = Math.min(y.value, window.innerHeight - buttonHeight);
};

// 挂载时添加窗口resize监听
onMounted(() => {
  window.addEventListener("resize", handleResize);
});

// 卸载时移除所有监听
onUnmounted(() => {
  window.removeEventListener("resize", handleResize);
  document.removeEventListener("mousemove", moveDrag);
  document.removeEventListener("touchmove", moveDrag);
  document.removeEventListener("mouseup", endDrag);
  document.removeEventListener("touchend", endDrag);
});
const dragButton = ref();
const close = () => {
  globalStore.setGlobalState("showDragButton", false);
};

// const formatVerifyStatusName = computed(() => {
//   switch (verifyStatus.value) {
//     case 0:
//       return "未实名";
//     case 1:
//       return "已实名";
//     case 2:
//       return "实名审核中";
//     case 3:
//       return "实名失败";
//     default:
//       return "未实名";
//   }
// });
const formatVerifystyle = computed(() => {
  switch (verifyStatus.value) {
    case 0:
      return "#2563EB";
    case 1:
      return "#67c23a";
    case 2:
      return "#2563EB";
    case 3:
      return "#2563EB";
    default:
      return "#2563EB";
  }
});

const stepStatuStyle = computed(() => {
  switch (stepStatus.value) {
    case 0:
      return "rgb(144, 147, 153)";
    case 1:
      return "#2563EB";
    case 2:
      return "#67c23a";
    case 3:
      return "#67c23a";
    default:
      return "rgb(144, 147, 153)";
  }
});

const stepStatuStyle1 = computed(() => {
  switch (stepStatus.value) {
    case 0:
      return "rgb(144, 147, 153)";
    case 1:
      return "rgb(144, 147, 153)";
    case 2:
      return "#2563EB";
    case 3:
      return "#67c23a";
    default:
      return "rgb(144, 147, 153)";
  }
});
// const verifyStatusType = computed(() => {
//   switch (verifyStatus.value) {
//     case 0:
//       return "primary";
//     case 1:
//       return "success";
//     case 2:
//       return "danger";
//     case 3:
//       return "danger";
//     default:
//       return "danger";
//   }
// });

const qurenzheng = () => {
  if (userStore.userInfo.verifyNum === 3) {
    ElMessage.error("您的实名次数已用完，请联系客服协助完成实名。");
  } else {
    router.push("/certification");
  }
};
</script>

<style scoped>
.drag-button {
  position: fixed; /* 固定定位，实现全局悬浮 */
  z-index: 9999; /* 确保在最上层 */
  width: 50px;
  height: 50px;
  line-height: 65px;
  color: white;
  text-align: center;
  cursor: move; /* 鼠标样式提示可拖拽 */ /* 禁止文本选中 */
  user-select: none;
  border-radius: 50%;
  box-shadow: 0 2px 12px rgb(0 0 0 / 10%);
  transition: background-color 0.3s ease;
}

/* 拖拽时添加缩放效果，增强反馈 */
.drag-button:active {
  transform: scale(1.05);
}
</style>
